export default "__VITE_ASSET__Cbd076fs__"